<template>
  <v-checkbox
    color="primary"
    :model-value="item[parameter]"
    :class="`${dirtyClass} center-field mt-0`"
    hide-details
    density="compact"
   @update:model-value="
      $emit('set', {
        value: $event,
        item: item,
        parameter: parameter,
      });
      $emit('update');
    "
    :disabled="disabled || !editable"
    :readonly="!editable"
  />
</template>

<script>
export default {
  name: "CheckBoxField",
  props: {
    parameter: { required: true },
    item: { required: true },
    selectedItem: { required: false, default: false },
    disabled: { default: false, required: false },
    dirtyClass: { required: false },
    editable: { default: true, required: false },
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    swatchStyle() {
      const { color, menu } = this;
      return {
        backgroundColor: color,
        height: "20px",
        width: "20px",
        borderRadius: menu ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
    color: {
      get() {
        return this.item[this.parameter];
      },
    },
  },
};
</script>

<style scoped>
.center-field {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
